import { List } from "antd";
import React from "react";
import "./style.css";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadApp } from "../../../Assets/Images";

const data = [
  { title: "Track your application" },
  { title: "Download your policy" },
  { title: "Avail your health card" },
  { title: "Renew your policy" },
  { title: "Make changes to your policy details" },
];

const DownloadAppCard = () => {
  return (
    <div className="download-card_container">
      <label>Access ManipalCigna from anywhere!</label>
      <List
        itemLayout="horizontal"
        dataSource={data}
        style={{ marginTop: "10px" }}
        renderItem={(item) => (
          <List.Item style={{ borderWidth: "0px" }}>
            <List.Item.Meta
              avatar={<FontAwesomeIcon icon={faCheckCircle} color="#50b848" />}
              title={item.title}
            />
          </List.Item>
        )}
      />
      <label>Download ManipalCigna App on</label>
      <a href="https://www.manipalcigna.com/mymanipalcignaapp" target="_blank" rel="noopener noreferrer">
        <img src={'/app-tracker/download-app.png'} />
      </a>
    </div>
  );
};

export default DownloadAppCard;
